// @flow

import get from 'lodash/get';
import flow from 'lodash/flow';
import split from 'lodash/split';
import nth from 'lodash/nth';
import replace from 'lodash/replace';

const getLocalValue = (str: string, localStorage: Storage) =>
  localStorage ? localStorage.getItem(str) : null;

const toJson = (str: string) => {
  try {
    return JSON.parse(str);
  } catch (e) {
    return null;
  }
};

const getAuthToken = (parsedToken: *) =>
  replace(get(parsedToken, 'data.token'), 'Bearer ');

const extractSeekerIdFromJwtPayload = (jwtString: string) => {
  try {
    const payloadString = nth(split(jwtString, '.', 2), 1);
    const payload = toJson(atob(payloadString));
    return get(payload, 'sub.id');
  } catch (e) {
    return null;
  }
};

const getJobSeekerId = (localStorage: Storage = window.localStorage) =>
  flow([getLocalValue, toJson, getAuthToken, extractSeekerIdFromJwtPayload])(
    'SeekAuthorisationToken',
    localStorage
  ) || '';

export default getJobSeekerId;
